import { useMemo } from 'react';
import { FIRM_ADMIN_VALUE } from 'common/constants/user';
import { UseStoreValue } from 'common/types/store';

const useReadUserAccessLevel = ({
  user,
  firmInfo,
}: {
  user: UseStoreValue['user'];
  firmInfo: UseStoreValue['firmInfo'];
}) => {
  const userFirmRole = useMemo(() => {
    if (!user || !firmInfo) {
      return null;
    }
    return (user.firms_permissions ?? []).find(permission => permission.name === firmInfo.name)?.user_firm_role ?? null;
  }, [user, firmInfo]);

  const isStaffOrSuperuser = useMemo(() => Boolean(user?.is_superuser || user?.is_staff), [user]);

  const isAdminOrStaffOrSuperuser = useMemo(
    () => isStaffOrSuperuser || userFirmRole === FIRM_ADMIN_VALUE,
    [isStaffOrSuperuser, userFirmRole]
  );
  return {
    isStaffOrSuperuser,
    isAdminOrStaffOrSuperuser,
    userFirmRole,
  };
};

export default useReadUserAccessLevel;
